import React, { createContext, useContext, useState, useEffect } from 'react';
import i18n from './i18n';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [isLanguageReady, setIsLanguageReady] = useState(false);

  useEffect(() => {
    // A inicialização do i18n por si só é assíncrona
    // O evento 'initialized' é disparado quando ela está completa
    const onInitialized = () => {
      setIsLanguageReady(true);
    };

    if (i18n.isInitialized) {
      // Se já estiver inicializado, defina o estado
      onInitialized();
    } else {
      // Caso contrário, ouça o evento 'initialized'
      i18n.on('initialized', onInitialized);
    }

    return () => {
      // Remova o listener para evitar memory leaks
      i18n.off('initialized', onInitialized);
    };
  }, []);

  // Fornece o estado para os componentes filhos
  return (
    <LanguageContext.Provider value={{ isLanguageReady }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);